import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import umbrella from 'umbrella-storage';
import { RootState } from '..'; // 在 store/index.ts 中声明的类型
import { UserVerifyStatus } from '../../enums/UserVerifyStatus';

// 借助 createSlice 创建 reducer、action
const VerifyStatusSlice = createSlice({
    name: 'verifyStatus',
    initialState: {
        value: UserVerifyStatus.Initial,
    },
    reducers: {
        setVerifyStatus: (state, action: PayloadAction<UserVerifyStatus>) => {
            state.value = action.payload;
        },
    },
});

// Action Creator 用于执行返回描述如何更新 state 的 Action
export const { setVerifyStatus } = VerifyStatusSlice.actions;

// Selector，作为 useSelector 读取数据的函数参数
export const verifyStatusSelector = (state: RootState) => state.verifyStatus.value;

// Reducer，真正执行修改 state 的纯函数
export default VerifyStatusSlice.reducer;
